export const SET_ORIGIN_DEMOGRAPHICS = 'SET_ORIGIN_DEMOGRAPHICS';
export const FETCH_ORIGIN_DEMOGRAPHICS = 'FETCH_ORIGIN_DEMOGRAPHICS';

